import * as React from 'react';
import type { ArrayDataType } from '@glueapp/graph-types';
import { ShapeTypeSelectorEditor } from './ShapeValueEditor';

interface ArrayValueEditorProps {
    value: ArrayDataType;
    onChange: (value: ArrayDataType) => void;
}

export const ShapeArrayEditor: React.FC<ArrayValueEditorProps> = ({ value, onChange }) => {
    return (
        <div className="flex flex-col gap-1.5 pt-1">
            <label className="text-xs font-medium text-muted-foreground">List of</label>
            <ShapeTypeSelectorEditor value={value.subType} onChange={newValue => onChange({ kind: 'array', subType: newValue })} />
        </div>
    );
};
